import { internalInstance } from 'v5/i18n.internal';
import { WithToastService } from 'v5/services/front/ToastService/ToastService';

/** The export ends well after the click, so the browser may block the new tab: then a toast offers it from a click. */
export function openReportFile(
  accessUrl: string,
  toastService: WithToastService['toastService']
) {
  if (window.open(accessUrl, '_blank')) return;
  const t = internalInstance.getFixedT(null, 'reporting', 'ReportFile');
  toastService.open({
    type: 'info',
    message: t('ready'),
    autoClose: false,
    action: {
      label: t('open'),
      onClick: () => window.open(accessUrl, '_blank')
    }
  });
}
